import React from 'react';

const Vue_TransitionGroup = () => {
  return (
    <div>
      <h1>Vue_TransitionGroup Component</h1>
      <p>This is the Vue_TransitionGroup tutorial page.</p>
    </div>
  );
}

export default Vue_TransitionGroup;
